module.exports = __webpack_public_path__ + "static/media/slide3.220ef270.jpg";